<template>
  <div :class="{ active: show }" class="modal-media">
    <div v-if="modal">
      <div class="header">
        <div class="radios">
          <input id="typeImage" type="radio" value="image" v-model="type" />
          <label for="typeImage">{{ parseTranslation(IMAGE) }}</label>

          <input id="typeVideo" type="radio" value="video" v-model="type" />
          <label for="typeVideo">{{ parseTranslation(VIDEO) }}</label>
        </div>

        <button class="close-modal" @click="closeModal"><Close /></button>
      </div>

      <div class="modal-content">
        <p>
          {{ parseTranslation(CHOOSE_PICTURE) }}
        </p>

        <div class="media">
          <div v-if="!loadingMedia && type === 'image'">
            <div v-if="image" class="range-wrapper">
              <input type="range" v-model="width" max="800" min="50" step="1" />
            </div>

            <div v-if="image" class="img-wrapper">
              <img ref="mediaPreview" :width="width" :src="image" />
            </div>

            <div v-if="!image" class="no-image-text">
              {{ parseTranslation(NO_IMAGE) }}
            </div>
          </div>

          <div v-if="!loadingMedia && type === 'video'">
            <div v-if="video" class="range-wrapper">
              <input type="range" v-model="width" max="800" min="50" step="1" />
            </div>

            <div v-if="video" class="img-wrapper">
              <video ref="mediaPreview" :width="width" :src="video" controls />
            </div>

            <div v-if="!video" class="no-image-text">
              {{ parseTranslation(NO_VIDEO) }}
            </div>
          </div>

          <div class="loader-media" v-if="loadingMedia">
            <Loader />
          </div>
        </div>

        <div class="buttons">
          <div v-if="addLabelOption && (image || video)" class="add-label-wrapper">
            <input
              type="checkbox"
              id="showLabel"
              :checked="showLabel"
              @change="handleShowLabelToggle"
            />
            <label for="showLabel">{{ parseTranslation(DISPLAY_LABEL) }}</label>
          </div>

          <button @click="deleteSurveyMedia">
            {{ parseTranslation(DELETE) }}
          </button>

          <button>
            <label for="inputImage">{{ parseTranslation(UPLOAD) }}</label>

            <input
              id="inputImage"
              @change="event => uploadMedia(event.target)"
              type="file"
              :accept="`${type}/*`"
            />
          </button>

          <button @click="sendMedia">
            <span v-if="!loading">{{ parseTranslation(APPLY) }}</span>
            <span v-else> {{ parseTranslation(LOADING) }}...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import { uploadFile } from '@/services/api'

import Close from '@/components/imgs/Close'
import Loader from '@/components/loading/Loader-2'

import { removeUndefinedProperties } from '@/utils/object'

import * as translationModalMedia from './MediaModal.translations'

const { default: translations, ...translationKeys } = translationModalMedia

export default {
  components: { Close, Loader },

  data() {
    return {
      translations,
      ...translationKeys,
      show: false,
      type: 'image',
      image: null,
      video: null,
      width: 300,
      loading: false,
      loadingMedia: false,
      addLabelOption: false,
      showLabel: false,
      alternativeName: null,
    }
  },

  computed: {
    modal() {
      return this.$store.getters.modalMedia
    },
  },

  watch: {
    modal() {
      if (this.modal) {
        this.openModal()
      }
    },
  },

  methods: {
    ...mapActions(['modalMedia', 'deleteMedia', 'mediaObj', 'sendMessage']),

    openModal() {
      this.addLabelOption = this.modal.addLabelOption
      this.alternativeName = this.modal.alternativeName || null

      if (!this.modal?.media) return (this.show = true)

      const hasAnswerAndSameUrl =
        this.modal?.answer && this.modal?.media?.url === this.modal?.answer?.media?.url

      const noAnswerAndSameUrl =
        !this.modal?.answer && this.modal?.media?.url === this.modal?.question?.media?.url

      this.showLabel = this.modal?.media?.showLabel || false

      if (!hasAnswerAndSameUrl && !noAnswerAndSameUrl) return (this.show = true)

      const type = this.modal.media.type

      this[type] = this.modal.media.url

      this.type = type

      this.width = this.modal.media.width

      this.show = true
    },

    handleShowLabelToggle() {
      this.showLabel = !this.showLabel
    },

    closeModal() {
      this.image = null
      this.video = null
      this.type = 'image'
      this.show = false
      this.width = 300
      this.alternativeName = null
      this.modalMedia(null)
    },

    deleteSurveyMedia() {
      const obj = {
        mediaId: this.modal.mediaId,
        qid: this.modal.question.qid,
        alternativeName: this.alternativeName,
      }

      if (this.modal?.answer) obj.answer = this.modal.answer

      this.deleteMedia(obj)
      this.closeModal()
    },

    async uploadMedia({ files }) {
      const [file] = files || []

      if (!file || !file?.type.startsWith(this.type)) return

      if (file && typeof file === 'string') return

      this.loadingMedia = true

      const { url } = await uploadFile(file)

      this[this.type] = url

      this.loadingMedia = false
    },

    sendMedia() {
      if (this.loading || this.loadingMedia) return

      const url = this[this.type]

      if (!url && !this.modal.media?.url) return

      this.loading = true

      const obj = {
        mediaId: this.modal.mediaId,
        sid: this.modal.sid,
        qid: this.modal.question.qid,
        type: this.type,
        width: this.$refs.mediaPreview.offsetWidth,
        height: this.$refs.mediaPreview.offsetHeight,
        showLabel: this.addLabelOption ? this.showLabel : undefined,
        answer: this.modal.answer || undefined,
        url: url,
        alternativeName: this.alternativeName,
      }

      console.log('media sent')
      console.log(obj)

      this.mediaObj(removeUndefinedProperties(obj))

      this.loading = false

      this.closeModal()
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-media {
  @include background-modal-config;

  &.active {
    display: flex;
  }

  .add-label-wrapper {
    display: flex;
    align-items: center;
    margin-right: auto;

    label {
      margin-left: 0.25rem;
    }

    .light & {
      label {
        color: $gray-2;
      }
    }
  }

  > div {
    margin: 0 10px;
    padding: 20px;
    border-radius: 3px;
    position: fixed;
    max-width: 80%;
    background: $gray-7;
    @include tipography(16);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.4);

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .radios {
        label,
        input {
          cursor: pointer;
        }

        input {
          &:focus {
            outline: none;
          }
        }

        label {
          margin: 0 20px 0 8px;
        }
      }

      .close-modal {
        background: $transparent;
        border: none;
        height: 15px;

        svg {
          @include boxSizing(15);
        }
      }
    }

    .modal-content {
      width: 100%;
      position: relative;

      p {
        margin-top: 20px;
        @include tipography(18);
        text-align: center;
        line-height: 20px;
      }

      .media {
        margin: 10px 0;

        .range-wrapper {
          input {
            margin: 20px 0;
            width: 100%;

            &:focus {
              outline: none;
            }
          }
        }

        .img-wrapper {
          padding: 5px;
          position: relative;
          width: 100%;
          min-height: 200px;
          max-height: 250px;
          overflow: auto;

          &::-webkit-scrollbar {
            width: 12px;
            height: 12px;
          }

          &::-webkit-scrollbar-thumb {
            background: $gray-4;
            background-clip: padding-box;
            border: 4px solid rgba(0, 0, 0, 0);
            border-radius: 10px;
          }
        }

        .no-image-text {
          width: 100%;
          height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;
          @include tipography(24);
          color: $gray-2;
        }

        .loader-media {
          @include flexMiddle;
        }
      }

      .buttons {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        button {
          margin-right: 20px;
          padding: 10px 20px;
          border-radius: 3px;
          @include tipography(11);
          letter-spacing: 3px;
          text-transform: uppercase;
          font-weight: bold;
          transition: all 0.3s ease;

          &:nth-of-type(1) {
            color: $pink;
            border: 1px solid $pink;
            background: white;

            &:hover {
              color: $white;
              background: $pink-2;
            }
          }

          &:nth-of-type(2) {
            padding: 10px 0;
            border: 1px solid $blue;
            background: $blue;

            label {
              cursor: pointer;
              padding: 10px 20px;
            }

            input {
              display: none;
            }

            &:hover {
              background: $blue-2;
            }
          }

          &:nth-of-type(3) {
            margin-right: 0;

            border: 1px solid $main;
            background: $main;

            &:hover {
              background: $gray-8;
            }
          }

          &:hover {
            transform: scale(1.01);
          }

          &:focus {
            outline: none;
          }
        }
      }
    }

    .light & {
      background: #fff;

      .header {
        color: $main-two;
      }

      .modal-content {
        p {
          color: $gray-2;
        }
      }
    }
  }
}
</style>
